import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { toast } from "react-toastify";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function AccountTypesPage({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [images, setImages] = useState([]);

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      heading: "",
      desc: "",
      btn1T: "",
      btn1L: "",
      btn2T: "",
      btn2L: "",
      cards: [
        {
          title: "",
          subTitle: "",
          icon: "",
        },
        {
          title: "",
          subTitle: "",
          icon: "",
        },
        {
          title: "",
          subTitle: "",
          icon: "",
        },
        {
          title: "",
          subTitle: "",
          icon: "",
        },
      ],
      language: item.attributes.language,
    }));
    setData(docs);

    let imgDocs = langs.map((item) => ({
      journeyImg: "",
      paymentsImg: "",
      language: item.attributes.language,
    }));
    setImages(imgDocs);

    async function getData() {
      await fetch(`${API}/account-type`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.data || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                heading: apiItem.heading || localItem.heading,
                desc: apiItem.desc || localItem.desc,
                btn1T: apiItem.btn1T || localItem.btn1T,
                btn1L: apiItem.btn1L || localItem.btn1L,
                btn2T: apiItem.btn2T || localItem.btn2T,
                btn2L: apiItem.btn2L || localItem.btn2L,
                cards: apiItem.cards || localItem.cards,
              };
            } else {
              return localItem;
            }
          });
        });

        const apiImages = response.data?.attributes?.images || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImages.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                paymentsImg: apiItem.paymentsImg || localItem.paymentsImg,
                journeyImg: apiItem.journeyImg || localItem.journeyImg,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = () => {
    fetch(`${API}/account-type`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { data: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleImageChange = (e, index, type) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedImages = [...images];

        updatedImages[index] = { ...updatedImages[index], [type]: iconURL };

        fetch(`${API}/account-type`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { images: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  return (
    <TabContext value={value}>
      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.accountType,
            CACHE_KEY.startupConfigs,

          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>
          Account Types Page Settings
        </h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

                  <h3>Middle Cards</h3>
                  <div className="mt-4 grid lg:grid-cols-2 grid-cols-1 ">
                    {[...Array(4)].map((_, idx) => (
                      <div key={idx} className="w-1/2 mt-4 mb-4">
                        <h3>Card {idx + 1}</h3>
                        <TextField
                          sx={{ width: 300, mt: 1 }}
                          label="Title"
                          variant="outlined"
                          size="small"
                          value={data[index]?.cards[idx]?.title || ""}
                          onChange={(e) => {
                            setData((prevData) =>
                              prevData.map((item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    cards: item.cards.map((card, j) => {
                                      if (j === idx) {
                                        return {
                                          ...card,
                                          title: e.target.value,
                                        };
                                      }
                                      return card;
                                    }),
                                  };
                                }
                                return item;
                              })
                            );
                          }}
                        />
                        <TextField
                          sx={{ width: 300, mt: 2 }}
                          label="Sub-Title"
                          variant="outlined"
                          multiline
                          rows={3}
                          value={data[index]?.cards[idx]?.subTitle || ""}
                          onChange={(e) => {
                            setData((prevData) =>
                              prevData.map((item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    cards: item.cards.map((card, j) => {
                                      if (j === idx) {
                                        return {
                                          ...card,
                                          subTitle: e.target.value,
                                        };
                                      }
                                      return card;
                                    }),
                                  };
                                }
                                return item;
                              })
                            );
                          }}
                        />
                        <input
                          style={{ marginTop: 10 }}
                          type="file"
                          accept="image/*"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const formData = new FormData();
                              formData.append("files", file);

                              try {
                                const response = await fetch(`${API}/upload`, {
                                  method: "POST",
                                  headers: {
                                    Authorization: `Bearer ${userToken}`,
                                  },
                                  body: formData,
                                });

                                const result = await response.json();
                                const iconURL = result[0]?.url;

                                setData((prevData) =>
                                  prevData.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        cards: item.cards.map((card, j) => {
                                          if (j === idx) {
                                            return {
                                              ...card,
                                              icon: iconURL, // Set the URL from the server response
                                            };
                                          }
                                          return card;
                                        }),
                                      };
                                    }
                                    return item;
                                  })
                                );
                              } catch (error) {
                                console.error("Error uploading image:", error);
                              }
                            }
                          }}
                        />
                        {data[index]?.cards[idx]?.icon && (
                          <img
                            src={SERVER_DOMAIN + data[index]?.cards[idx]?.icon}
                            alt={`Card ${idx + 1} Icon`}
                            style={{ width: 50, height: 50, marginTop: 10 }}
                          />
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="divider"></div>

                  <h3>Headings</h3>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                      marginTop: 10,
                    }}
                  >
                    <TextField
                      sx={{ width: 400 }}
                      label="Payments Heading"
                      variant="outlined"
                      value={data[index]?.heading || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, heading: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      sx={{ width: 400 }}
                      label="Start your journey sub-title"
                      variant="outlined"
                      multiline
                      rows={4}
                      value={data[index]?.desc || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                desc: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <div>
                      <TextField
                        sx={{ width: 300, mr: 3, mb: 1 }}
                        label="Button One Text"
                        variant="outlined"
                        value={data[index]?.btn1T || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btn1T: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <TextField
                        sx={{ width: 300 }}
                        label="Button One Link"
                        variant="outlined"
                        value={data[index]?.btn1L || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btn1L: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                    <div>
                      <TextField
                        sx={{ width: 300, mr: 3, mb: 1 }}
                        label="Button Two Text"
                        variant="outlined"
                        value={data[index]?.btn2T || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btn2T: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <TextField
                        sx={{ width: 300 }}
                        label="Button Two Link"
                        variant="outlined"
                        value={data[index]?.btn2L || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btn2L: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                  </div>

                  {user.perms[12].edit && (
                    <>
                      <div
                        className="submitBTN"
                        onClick={() => submitData(item, index)}
                      >
                        Save Changes
                      </div>

                      <div className="divider"></div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: 25,
                          flexWrap: "wrap",
                        }}
                      >
                        <div className="w-4/12 mt-7">
                          <h3 className="ml-3">Payments Image</h3>

                          <div
                            className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.paymentsImg
                                  ? SERVER_DOMAIN + images[index]?.paymentsImg
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "paymentsImg")
                              }
                              ref={hiddenFileInput}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>

                        <div className="w-4/12 mt-7">
                          <h3 className="ml-3">Journey Image</h3>

                          <div
                            className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput2.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.journeyImg
                                  ? SERVER_DOMAIN + images[index]?.journeyImg
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "journeyImg")
                              }
                              ref={hiddenFileInput2}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
